import {useAlgoliaShopConfig} from "@/providers/AlgoliaShopConfigProvider.tsx";

export const useCustomizedUrl = () => {
    const { algoliaConfig:{customizedUrl} } = useAlgoliaShopConfig();
    return customizedUrl;
};